export default "__VITE_ASSET__D1DlZFvM__"